module.exports = __webpack_public_path__ + "img/1_6.a4b6e337.png";